(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pl--announcement-banner-4"] && !Shopify.designMode) return;
  try {
    
  const duplicateBannerContent = () => {
    const parents = document.querySelectorAll('[banner-data="parent"]')

    if (parents.length === 0) return

    for (const parent of parents) {
      const child = parent.querySelector('[banner-data="duplicate"]')
      if (!child) continue

      if (parent.children.length >= 2) continue

      const duplicate = child.cloneNode(true)
      parent.appendChild(duplicate)
    }
  }

  // Handle initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', duplicateBannerContent)
  } else {
    duplicateBannerContent()
  }

  // Handle theme editor changes
  document.addEventListener('shopify:section:load', duplicateBannerContent)
  document.addEventListener('shopify:section:reorder', duplicateBannerContent)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl--announcement-banner-5"] && !Shopify.designMode) return;
  try {
    
  const duplicateBannerContent = () => {
    const parents = document.querySelectorAll('[banner-data="parent"]')

    if (parents.length === 0) return

    for (const parent of parents) {
      const child = parent.querySelector('[banner-data="duplicate"]')
      if (!child) continue

      if (parent.children.length > 1) continue

      const duplicate = child.cloneNode(true)
      parent.appendChild(duplicate)
    }
  }

  // Handle initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', duplicateBannerContent)
  } else {
    duplicateBannerContent()
  }

  // Handle theme editor changes
  document.addEventListener('shopify:section:load', duplicateBannerContent)
  document.addEventListener('shopify:section:reorder', duplicateBannerContent)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl--search-page-1"]) return;
  try {
    
        ;(function () {
          // Prefill search input with query from URL or data attribute
          function prefillSearchInput() {
            // Try to get query from data attribute first, then from URL
            const wrapper = document.querySelector('[data-search-query]')
            let query = wrapper?.getAttribute('data-search-query') || ''

            // If no query in data attribute, try to get from URL params
            if (!query) {
              const urlParams = new URLSearchParams(window.location.search)
              query = urlParams.get('q') || ''
            }

            if (query) {
              // Wait for custom element to be defined and ready
              const trySetQuery = (retries = 0) => {
                const searchInput = document.querySelector('#search-page-input')
                if (!searchInput) {
                  // Retry if input not found yet (max 10 retries = 500ms)
                  if (retries < 10) {
                    setTimeout(() => trySetQuery(retries + 1), 50)
                  }
                  return
                }

                const plSearchInput = searchInput.closest('pl-search-input')

                // Try to set via custom element method first
                if (plSearchInput && typeof plSearchInput.setQuery === 'function') {
                  plSearchInput.setQuery(query)
                  return
                }

                // Fallback: set directly on the input element
                // This ensures the value is set even if custom element isn't ready
                if (searchInput.value !== query) {
                  searchInput.value = query

                  // Update clear button visibility manually
                  const clearButton = searchInput
                    .closest('pl-search-input')
                    ?.querySelector('[data-search-clear]')
                  if (clearButton && query.trim()) {
                    clearButton.setAttribute('data-visible', '')
                  }

                  // Also trigger input event to ensure custom element updates
                  searchInput.dispatchEvent(new Event('input', { bubbles: true }))
                }
              }

              // Wait for custom elements to be defined
              if (customElements.get('pl-search-input')) {
                // Element is defined, try to set immediately
                setTimeout(trySetQuery, 0)
              } else {
                // Wait for custom element to be defined
                customElements.whenDefined('pl-search-input').then(() => {
                  setTimeout(trySetQuery, 0)
                })
              }
            }
          }

          // Handle search:query events - only navigate on Enter key (fromEnter flag)
          function handleSearchQuery(event, forceSearch = false) {
            // Only handle searches triggered by Enter key, not debounced input
            if (!event.detail?.fromEnter && !forceSearch) {
              return
            }

            const query = event.detail?.query || ''
            const searchUrl = Theme?.routes?.search_url || '/search'

            if (query.trim()) {
              const url = new URL(searchUrl, window.location.origin)
              url.searchParams.set('q', query.trim())
              window.location.href = url.toString()
            } else {
              // If query is empty, go to search page without query
              window.location.href = searchUrl
            }
          }

          // Handle search:cleared events - navigate to search page without query
          function handleSearchCleared(event) {
            event?.preventDefault?.()
            event?.stopPropagation?.()
            const searchUrl = Theme?.routes?.search_url || '/search'
            // Navigate to search page without query parameter to show all products
            window.location.href = searchUrl
          }

          // Initialize on DOM ready
          function initialize() {
            prefillSearchInput()

            // Listen for search events on document (for bubbling events)
            document.addEventListener('search:query', handleSearchQuery)
            document.addEventListener('search:cleared', handleSearchCleared)

            // Also listen directly on the search input element as a fallback
            const attachDirectListener = (retries = 0) => {
              const searchInputElement = document.querySelector('#search-page-input')
              if (searchInputElement) {
                const plSearchInput = searchInputElement.closest('pl-search-input')
                if (plSearchInput) {
                  plSearchInput.addEventListener('search:cleared', handleSearchCleared)
                  return
                }
              }

              // Retry if element not found yet (max 10 retries = 500ms)
              if (retries < 10) {
                setTimeout(() => attachDirectListener(retries + 1), 50)
              }
            }

            attachDirectListener()
          }

          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initialize)
          } else {
            initialize()
          }
        })()
      
  } catch(e) { console.error(e); }
})();
})();
